import React from "react";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridToolbar, frFR } from "@mui/x-data-grid";
import { useDemoData } from "@mui/x-data-grid-generator";
import { toast } from "react-toastify";
import SuiviTelephoniqueService from "../../services/suivi-telephonique-service";
import EditCompteRendu from "../../pages/appel/edit-appel";

// Champs visibles dans le tableau
const VISIBLE_FIELDS = [
  "id",
  "subscription_date",
  "created_at",
];

const DataTableMonSuivi = ({ contacts, statuts, sendUpdate }) => {
  const [pageSize, setPageSize] = React.useState(5);

  // Modèle de visibilité des colonnes
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    id: false, // masqué
    contact_name: true, // visible
    date_appel: true, // visible
    statut_appel: true, // visible
    commentaires: true, // visible
    subscription_date: false, // masqué
    created_at: false, // masqué
  });

  const columns = [
    {
      field: "id",
      headerClassName: "header-prog31",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "contact_name",
      headerClassName: "header-prog31",
      headerName: "Contact",
      flex: 1,
    },
    {
      field: "date_appel",
      headerClassName: "header-prog31",
      headerName: "Date d'appel",
      flex: 1,
    },
    {
      field: "statut_appel",
      headerClassName: "header-prog31",
      headerName: "Statut d'appel",
      flex: 1,
    },
    {
      field: "commentaires",
      headerClassName: "header-prog31",
      headerName: "Commentaires",
      flex: 1,
    },
    {
      field: "subscription_date",
      headerClassName: "header-prog31",
      headerName: "Date de saisie",
      flex: 1,
    },
    {
      field: "created_at",
      headerClassName: "header-prog31",
      headerName: "Créé le",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header-prog31",
      renderCell: (id) => (
        <>
          <EditCompteRendu
            nc={id.row}
            id={id}
            statuts={statuts}
            sendUpdate={sendUpdate}
          />
          <Button
            id="deleteBtn"
            style={{
              backgroundColor: "#e8605d",
              color: "#fff",
              padding: "7px 7px",
            }}
            onClick={() => {
              if (
                window.confirm(
                  "Êtes-vous sûr de vouloir supprimer cet enregistrement ?"
                )
              ) {
                handleDelete(id);
              }
            }}
            variant="contained"
            color="primary"
            type="submit"
          >
            <DeleteIcon />
          </Button>
        </>
      ),
    },
  ];

  const { data } = useDemoData({
    dataSet: "Commodity",
    rowLength: 100,
    maxColumns: 6,
    visibleFields: VISIBLE_FIELDS,
  });

  const handleDelete = (id) => {
    SuiviTelephoniqueService.remove(id.id).then((data) => {
      console.log(data);
      toast.success("Contact supprimé!", {
        autoClose: 2000, // Durée d'affichage du toast en millisecondes (2 secondes dans cet exemple)
        onClose: () => {},
      });
      sendUpdate(true);
    });
  };

  return (
    <div style={{ height: 450, width: "100%" }}>
      <DataGrid
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        {...data}
        initialState={{
          sorting: {
            sortModel: [{ field: "id", sort: "desc" }],
          },
        }}
        components={{ Toolbar: GridToolbar }}
        rows={contacts}
        columns={columns}
        columnVisibilityModel={columnVisibilityModel} // modèle de visibilité dynamique
        onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)} // permet de gérer dynamiquement la visibilité
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        pagination
        rowHeight={40}
      />
    </div>
  );
};

export default DataTableMonSuivi;
